export function fixQuotedArrays(buffer) {
    let processed = buffer;
    processed = processed.replace(/":\s*"\[\s*([\s\S]*?)\s*\]"/g, (_match, inner) => {
        const cleanedInner = inner.replace(/\\"/g, '"');
        return '": [' + cleanedInner + "]";
    });
    processed = processed.replace(/':\s*'\[\s*([\s\S]*?)\s*\]'/g, (_match, inner) => {
        return "': [" + inner + "]";
    });
    processed = processed.replace(/\]"\s*,/g, "],");
    processed = processed.replace(/\]"\s*\}/g, "]}");
    return processed;
}
export function closeOpenBrackets(buffer) {
    const stack = [];
    let inQuotes = false;
    let quoteChar = null;
    let escape = false;
    let inArray = false;
    let braceBalance = 0;
    const result = [];
    for (let i = 0; i < buffer.length; i += 1) {
        const char = buffer[i];
        if (escape) {
            escape = false;
            result.push(char);
            continue;
        }
        if (char === "\\") {
            escape = true;
            result.push(char);
            continue;
        }
        if ((char === '"' || char === "'") && !escape) {
            if (!inQuotes) {
                inQuotes = true;
                quoteChar = char;
            }
            else if (char === quoteChar) {
                inQuotes = false;
            }
            result.push(char);
            continue;
        }
        if (!inQuotes) {
            if (char === "[") {
                inArray = true;
                stack.push(char);
            }
            else if (char === "]") {
                if (stack.length > 0 && stack[stack.length - 1] === "[") {
                    inArray = stack.filter((item) => item === "[").length <= 1;
                    stack.pop();
                }
            }
            else if (char === "{") {
                if (inArray)
                    braceBalance += 1;
                stack.push(char);
            }
            else if (char === "}") {
                if (inArray && braceBalance > 0)
                    braceBalance -= 1;
                if (inArray && braceBalance < 0) {
                    braceBalance = 0;
                    continue;
                }
                if (stack.length > 0 && stack[stack.length - 1] === "{") {
                    stack.pop();
                }
                else {
                    continue;
                }
            }
        }
        result.push(char);
    }
    let finalBuffer = result.join("");
    if (stack.length > 0) {
        const lastCommaIndex = finalBuffer.lastIndexOf(",");
        if (lastCommaIndex !== -1 && lastCommaIndex > finalBuffer.length - 15) {
            const afterComma = finalBuffer.slice(lastCommaIndex);
            const hasOpenBracketAfter = /[\[{]/.test(afterComma);
            if (!hasOpenBracketAfter) {
                finalBuffer = finalBuffer.slice(0, lastCommaIndex) + finalBuffer.slice(lastCommaIndex + 1);
            }
        }
    }
    if (inQuotes && quoteChar) {
        finalBuffer += quoteChar;
    }
    for (let j = stack.length - 1; j >= 0; j -= 1) {
        finalBuffer += stack[j] === "[" ? "]" : "}";
    }
    return finalBuffer;
}
export function tryParseJSON(buffer) {
    if (!buffer || buffer.trim().length === 0) {
        return { success: false, error: "Empty buffer" };
    }
    try {
        let fixed = fixQuotedArrays(buffer);
        fixed = closeOpenBrackets(fixed);
        const data = JSON.parse(fixed);
        return { success: true, data };
    }
    catch (error) {
        return { success: false, error: error instanceof Error ? error.message : String(error) };
    }
}
export function checkType(value, expectedType) {
    switch (expectedType) {
        case "array":
            return Array.isArray(value);
        case "object":
            return typeof value === "object" && value !== null && !Array.isArray(value);
        case "string":
            return typeof value === "string";
        case "number":
            return typeof value === "number";
        case "boolean":
            return typeof value === "boolean";
        default:
            return false;
    }
}
export function extractValueAtPath(obj, path) {
    if (!obj || typeof obj !== "object")
        return undefined;
    const parts = path.split(".");
    let current = obj;
    for (const part of parts) {
        if (current === null || current === undefined || typeof current !== "object") {
            return undefined;
        }
        current = current[part];
    }
    return current;
}
export function hasValueAtPath(obj, path) {
    return extractValueAtPath(obj, path) !== undefined;
}
export function extractItemsIfNeeded(fieldValue) {
    if (fieldValue !== null &&
        typeof fieldValue === "object" &&
        !Array.isArray(fieldValue) &&
        "items" in fieldValue) {
        return fieldValue.items;
    }
    return fieldValue;
}
export function extractListItems(rawList, checkSubField) {
    const items = [];
    const seenItems = new Set();
    if (!rawList.startsWith("["))
        return items;
    const completeList = tryExtractCompleteList(rawList);
    if (completeList !== null) {
        for (const item of completeList) {
            if (isValidItem(item, checkSubField)) {
                const itemRepr = JSON.stringify(item);
                if (!seenItems.has(itemRepr)) {
                    items.push(item);
                    seenItems.add(itemRepr);
                }
            }
        }
        return items;
    }
    const objectBoundaries = findObjectBoundaries(rawList);
    for (const [start, end] of objectBoundaries) {
        const objText = rawList.slice(start, end + 1);
        try {
            const obj = JSON.parse(objText);
            if (isValidItem(obj, checkSubField)) {
                const itemRepr = JSON.stringify(obj);
                if (!seenItems.has(itemRepr)) {
                    items.push(obj);
                    seenItems.add(itemRepr);
                }
            }
        }
        catch {
            // ignore incomplete item
        }
    }
    return items;
}
function tryExtractCompleteList(rawList) {
    let depth = 1;
    let inString = false;
    let escape = false;
    let closingBracketIdx = null;
    for (let i = 1; i < rawList.length; i += 1) {
        const char = rawList[i];
        if (escape) {
            escape = false;
            continue;
        }
        if (char === "\\") {
            escape = true;
            continue;
        }
        if (char === '"' && !escape) {
            inString = !inString;
            continue;
        }
        if (!inString) {
            if (char === "[")
                depth += 1;
            else if (char === "]") {
                depth -= 1;
                if (depth === 0) {
                    closingBracketIdx = i;
                    break;
                }
            }
        }
    }
    if (closingBracketIdx !== null) {
        const completeListStr = rawList.slice(0, closingBracketIdx + 1);
        try {
            const parsed = JSON.parse(completeListStr);
            if (Array.isArray(parsed))
                return parsed;
        }
        catch {
            // not parseable yet
        }
    }
    return null;
}
function findObjectBoundaries(rawList) {
    const boundaries = [];
    const openObjects = [];
    let inString = false;
    let escape = false;
    for (let i = 0; i < rawList.length; i += 1) {
        const char = rawList[i];
        if (escape) {
            escape = false;
            continue;
        }
        if (char === "\\") {
            escape = true;
            continue;
        }
        if (char === '"' && !escape) {
            inString = !inString;
            continue;
        }
        if (!inString) {
            if (char === "{") {
                openObjects.push(i);
            }
            else if (char === "}" && openObjects.length > 0) {
                const startPos = openObjects.pop();
                if (openObjects.length === 0) {
                    boundaries.push([startPos, i]);
                }
            }
        }
    }
    return boundaries;
}
function isValidItem(item, checkSubField) {
    if (typeof item !== "object" || item === null || Array.isArray(item))
        return false;
    if (checkSubField)
        return checkSubField in item;
    return true;
}
export function isBalanced(buffer) {
    const stack = [];
    let inQuotes = false;
    let quoteChar = null;
    let escape = false;
    for (const char of buffer) {
        if (escape) {
            escape = false;
            continue;
        }
        if (char === "\\") {
            escape = true;
            continue;
        }
        if (char === '"' || char === "'") {
            if (!inQuotes) {
                inQuotes = true;
                quoteChar = char;
            }
            else if (char === quoteChar) {
                inQuotes = false;
            }
            continue;
        }
        if (!inQuotes) {
            if (char === "[" || char === "{") {
                stack.push(char);
            }
            else if (char === "]" || char === "}") {
                if (stack.length === 0)
                    return false;
                const top = stack[stack.length - 1];
                if ((char === "]" && top === "[") || (char === "}" && top === "{")) {
                    stack.pop();
                }
                else {
                    return false;
                }
            }
        }
    }
    return stack.length === 0 && !inQuotes;
}
